import React from "react";
import { Divider } from "~/native-ui/Divider";

export class MenuDivider extends React.Component {
    render() {
        return <Divider w="100%" my="1" { ...this.props } />
    }
}